import { QualityRecordStatus } from '@/entities/Document';
import type { GeneratedRecordInspectionType } from '@/entities/GeneratedRecord';
import type { EntityType } from '@/shared/lib';

// ==================== LABELS ====================

export const QualityRecordStatusLabels: Record<QualityRecordStatus, string> = {
  [QualityRecordStatus.DISPONIVEL]: 'Disponível',
  [QualityRecordStatus.EM_USO]: 'Em uso',
  [QualityRecordStatus.ARQUIVADO]: 'Arquivado',
};

export const GENERATED_RECORDS_EMPTY_TITLE = 'Ops! Parece que ainda não há Registros gerados.';

export const GENERATED_RECORDS_LOAD_ERROR_TITLE = 'Não foi possível carregar os Registros.';

export const MATRIX_REVISIONS_LOAD_ERROR_TITLE = 'Não foi possível carregar as matrizes';

export const MATRIX_PAGE_LOAD_ERROR_TITLE = 'Não foi possível carregar a matriz';

export const GENERATED_RECORD_STAGES_LOAD_ERROR = {
  title: 'Erro ao carregar as etapas',
  message: 'O filtro por etapa fica indisponível. Tente novamente mais tarde.',
} as const;

export const GENERATED_RECORD_FILTER_APPLY_ERROR = {
  title: 'Erro ao aplicar o filtro',
  message: 'A listagem foi mantida como estava. Tente novamente.',
} as const;

export const GENERATED_RECORDS_PAGINATION_ENTITY = 'registro gerado' satisfies EntityType;

export const MATRIX_NOT_FOUND_TOAST_TITLE = 'Não foi possível encontrar a matriz.';

export const MATRIX_REVISIONS_EMPTY_TITLE = 'Nenhuma matriz encontrada';

export const MATRIX_REVISIONS_RESTRICTED_TITLE = 'Acesso restrito às matrizes';

export const MATRIX_REVISIONS_RESTRICTED_DESCRIPTION =
  'Você não tem permissão para visualizar as matrizes. Caso precise de acesso, entre em contato com o administrador do sistema.';

export interface InspectionIdentifierModalTexts {
  title: string;
  label: string;
  placeholder: string;
}

export const INSPECTION_IDENTIFIER_MAX_LENGTH = 100;

export const INSPECTION_IDENTIFIER_MODAL_TEXTS: Record<
  GeneratedRecordInspectionType,
  InspectionIdentifierModalTexts
> = {
  NEW_DEVICE: {
    title: 'Aparelho novo',
    label: 'Nº de série:',
    placeholder: 'Insira o código aqui',
  },
  ASSISTENCE_DEVICE: {
    title: 'Aparelho de assistência técnica',
    label: 'Nº da OS:',
    placeholder: 'Insira o número aqui',
  },
};

// ==================== CSS CLASSES ====================

// Only the fill and the border: `DocumentRevisionStatusDot` concatenates the shape base, which this
// layer cannot reach. Mapping these to `DocumentRevisionStatus` instead would paint DISPONIVEL and
// EM_USO the same green, because the shared map answers CURRENT and IN_USE with the same classes.
export const QualityRecordStatusDotColorClasses: Record<QualityRecordStatus, string> = {
  [QualityRecordStatus.DISPONIVEL]: 'bg-green-20 border-green-19',
  [QualityRecordStatus.EM_USO]: 'bg-pink-11-100 border-red-17/50',
  [QualityRecordStatus.ARQUIVADO]: 'bg-gray-02 border-gray-400',
};

// The layout paints every stage with this one gray: the stage is told apart by its label alone.
export const QUALITY_RECORD_STAGE_BADGE_CLASS =
  'px-3 py-1 rounded-full text-xs/3.5 font-medium inline-block whitespace-nowrap bg-gray-15 text-white';

// ==================== HELPER FUNCTIONS ====================

export function getQualityRecordStatusDotColorClass(status: QualityRecordStatus): string {
  return (
    QualityRecordStatusDotColorClasses[status] ??
    QualityRecordStatusDotColorClasses[QualityRecordStatus.DISPONIVEL]
  );
}

export function getQualityRecordStatusLabel(status: QualityRecordStatus): string {
  return QualityRecordStatusLabels[status] ?? 'N/A';
}
